import type { SVGProps } from 'react';
import React from 'react';

export const Web = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#00B3BF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M.5 4.5h20M3.5 2.25a.25.25 0 100 .5.25.25 0 000-.5v0M5.5 2.25a.25.25 0 100 .5.25.25 0 000-.5v0M7.5 2.25a.25.25 0 100 .5.25.25 0 000-.5v0"
    ></path>
    <path
      stroke="#00B3BF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.5 16.5h-5a2 2 0 01-2-2v-12a2 2 0 012-2h16a2 2 0 012 2v6"
    ></path>
    <path
      stroke="#00B3BF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.5 23.5c-2-1.5-3-4.5-3-7s1-5.5 3-7M16.5 23.5c2-1.5 3-4.5 3-7s-1-5.5-3-7M10.174 13.5h12.652M10.174 19.5h12.652M9.5 16.5h14"
    ></path>
    <circle
      cx="16.5"
      cy="16.5"
      r="7"
      stroke="#00B3BF"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></circle>
  </svg>
);
